'use client';

import EditableMarkdownV2 from "@/app/features/shared/editable-markdown/EditableMarkdownV2";
import useMarkdownEditScrollLock
    from "@/app/features/shared/editable-markdown/hooks/useMarkdownEditScrollLock";
import { usePrivacyEditor } from "@/app/features/sites/privacy/contexts/PrivacyEditorContext";
import PrivacyPageRootFrame from "@/app/features/sites/privacy/ui/shared/PrivacyPageFrames";

export default function PrivacyPageEditable() {
    const { editable, updateEditable, errorForField } = usePrivacyEditor();
    const { isMarkdownEditing, onMarkdownEditingChange } = useMarkdownEditScrollLock();
    const contentError = errorForField?.("content") ?? undefined;

    return (
        <PrivacyPageRootFrame constrainToViewport={isMarkdownEditing}>
            <EditableMarkdownV2
                label="Inhalt"
                ariaLabel="Datenschutzerklärung bearbeiten"
                required
                value={editable?.content ?? ""}
                onChange={(content) => updateEditable({ content })}
                onEditingChange={onMarkdownEditingChange}
                error={Boolean(contentError)}
                helperText={contentError}
            />
        </PrivacyPageRootFrame>
    );
}
